import { useState } from 'react';
import { useMutation } from "@tanstack/react-query";
import { usePassport } from '../../../hooks/usePassport';

const TeacherCodeModal = ({ form, onClose }) => {
	const API_URL = import.meta.env.VITE_API_URL;
	const { passport } = usePassport();
	const [password, setPassword] = useState();

	const mutation = useMutation({
		mutationFn: async (data: { exploreCode: string, exploreLevel: string, successType: string, successId: string, password: string }) => {
			const params = new URLSearchParams();
			Object.entries(data).forEach(([key, value]) => {
				params.append(key, value);
			});

			const response = await fetch(`${API_URL}/bbs/ajax.update_passport.php`, {
				method: "POST",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
				body: params,
			});
			
			if (!response.ok) throw new Error("네트워크 오류");

			return response.json();
		},
		onSuccess: (response) => {
			if(!response.success) {
				switch (response.code) {
					case "INVALID_REQUEST":
						alert("필수 필드값이 입력되지 않았습니다.");
						break;
					case "NOT_MATCH_PASSPORT_PASSWORD":
						alert("PIN 번호가 일치하지 않습니다.");
						break;
					default :
						alert("알 수 없는 오류가 발생했습니다.");
						break;
				}
				return;
			}

			if(!response.success) {
				alert("알 수 없는 오류가 발생했습니다.");
				return;
			}

			if(response.success) {
				// 성공
			}
		},
		onError: (error: any) => {
			alert(error.message);
		}
	});

	const handleChange = (e) => {
		let value = e.target.value;
		value = value.replace(/[^0-9]/g, '');
		if (value.length > 4) return;
		setPassword(value);
	};

	const handleClick = () => {
		if (!/^\d{4}$/.test(password)) {
			alert("비밀번호는 숫자 4자리여야 합니다.");
			return;
		}
		mutation.mutate({...form, password});
	};

	return (
		<div className="fixed inset-0 bg-black/70 z-[1000] flex items-center justify-center p-5 backdrop-blur-sm">
			<div className="bg-white rounded-[20px] p-10 max-w-[500px] w-full shadow-[0_20px_60px_rgba(0,0,0,0.3)]">
				<h3 className="text-2xl font-bold mb-4 text-center">선생님 인증</h3>
				<p className="text-center mb-6 text-gray-600" id="pinMessage">
					스탬프 인증을 위한 PIN을 입력하세요
				</p>
				<input 
					type="password"
					name="password"
					id="password"
					onChange={handleChange}
					value={password}
					maxLength="4" 
					className="w-full px-4 py-3 text-center text-2xl font-bold border-2 border-blue-300 rounded-xl mb-4 focus:outline-none focus:border-blue-500 transition-colors" 
					placeholder="• • • •"
				/>
				<div className="flex gap-4">
					<button 
						onClick={onClose}
						className="flex-1 bg-gray-200 px-6 py-3 rounded-xl font-bold hover:bg-gray-300 transition-colors"
					>
						취소
					</button>
					<button 
						onClick={handleClick}
						className="flex-1 bg-blue-600 text-white px-6 py-3 rounded-xl font-bold hover:bg-blue-700 transition-colors"
					>
						확인
					</button>
				</div>
				<p className="text-xs text-center mt-4 text-gray-500">초기 비밀번호는 보호자 휴대전화번호 뒷자리 4자리입니다.</p>
			</div>
		</div>
	);
}

export default TeacherCodeModal;